// // // export async function getCategories() {
// // //     const response = await fetch(
// // //     "https://livestream.techzeus.co/api/job-categories?pagination[page]=1&pagination[pageSize]=100&sort=id:asc"
// // // );

// // //     console.log("Category Status:", response.status);

// // //     if (!response.ok) {
// // //         throw new Error(`Failed to fetch categories. Status: ${response.status}`);
// // //     }

// // //     const data = await response.json();

// // //     console.log("========== CATEGORY RESPONSE ==========");
// // //     console.log(JSON.stringify(data.data, null, 2));
// // //     console.log("=======================================");

// // //     console.log(
// // //         "Total Categories:",
// // //         (data.data || []).length
// // //     );

// // //     return data;
// // // } 

// // import { getToken } from "./api";

// // export async function getCategories() {
// //     const token = await getToken();

// //     if (!token) {
// //         throw new Error("Authentication token not found. Please login again.");
// //     }

// //     const response = await fetch(
// //         "https://livestream.techzeus.co/api/job-categories?pagination[page]=1&pagination[pageSize]=100&sort=id:asc",
// //         {
// //             method: "GET",
// //             headers: {
// //                 Authorization: `Bearer ${token}`,
// //             },
// //         }
// //     );

// //     console.log("Category Status:", response.status);

// //     if (!response.ok) {
// //         throw new Error(`Failed to fetch categories. Status: ${response.status}`);
// //     }

// //     const data = await response.json();

// //     console.log("========== CATEGORY RESPONSE ==========");
// //     console.log(JSON.stringify(data.data, null, 2));
// //     console.log("=======================================");

// //     console.log(
// //         "Total Categories:",
// //         (data.data || []).length
// //     );

// //     return data;
// // }

// const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

// export async function getCategories() {
//     // Get logged-in user's ID from local storage
    
//     const storedUser = localStorage.getItem("user");
//     const user = storedUser ? JSON.parse(storedUser) : null;
//     const userId = user?.id;

//     if (!userId) {
//         throw new Error("User ID not found. Please login again.");
//     }

//     const response = await fetch(`${API_URL}/api/auth/job-categories`, {
//         method: "GET",
//         headers: {
//             "Content-Type": "application/json",
//             "X-User-ID": userId,
//         },
//         credentials: "include",
//     });

//     console.log("Category Status:", response.status);

//     if (!response.ok) {
//         let errorMessage = "Failed to fetch categories.";

//         try {
//             const errorData = await response.json();
//             errorMessage =
//                 errorData.detail || errorData.message || errorMessage;
//         } catch (error) {
//             // Response was not JSON
//         }

//         throw new Error(errorMessage);
//     }

//     const data = await response.json();

//     console.log("========== CATEGORY RESPONSE ==========");
//     console.log(JSON.stringify(data.data, null, 2));
//     console.log("=======================================");

//     console.log("Total Categories:", (data.data || []).length);

//     return data;
// }

const API_URL =
    process.env.REACT_APP_API_URL || "http://localhost:8000";

export async function getCategories() {
    const storedUser = localStorage.getItem("user");
    const user = storedUser ? JSON.parse(storedUser) : null;
    const userId = user?.id;

    if (!userId) {
        throw new Error("User ID not found. Please login again.");
    }

    const response = await fetch(
        `${API_URL}/api/auth/job-categories`,
        {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "X-User-ID": String(userId),
            },
        }
    );

    console.log("Category Status:", response.status);
    console.log("X-User-ID:", userId);

    if (!response.ok) {
        let errorMessage = "Failed to fetch categories.";

        try {
            const errorData = await response.json();

            errorMessage =
                errorData.detail ||
                errorData.message ||
                errorMessage;
        } catch (error) {
            // Response was not JSON
        }

        throw new Error(errorMessage);
    }

    const data = await response.json();

    console.log("========== CATEGORY RESPONSE ==========");
    console.log(JSON.stringify(data.data, null, 2));
    console.log("=======================================");

    return data;
}